import { Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { PasswordGate } from '@/components/auth/PasswordGate';
import { Dashboard } from '@/pages/Dashboard';
import { SiteDetail } from '@/pages/SiteDetail';
import { Comparison } from '@/pages/Comparison';
import { Trends } from '@/pages/Trends';
import { SemReport } from '@/pages/SemReport';
import { SeoReport } from '@/pages/SeoReport';

function App() {
  return (
    <PasswordGate>
      <Layout>
        <Routes>
          <Route path="/" element={<SemReport />} />
          <Route path="/web-audit" element={<Dashboard />} />
          <Route path="/site/:siteId" element={<SiteDetail />} />
          <Route path="/compare" element={<Comparison />} />
          <Route path="/trends" element={<Trends />} />
          <Route path="/sem" element={<SemReport />} />
          <Route path="/seo" element={<SeoReport />} />
        </Routes>
      </Layout>
    </PasswordGate>
  );
}

export default App;
